// src/pages/PaymentCancel.js

export default function PaymentCancel() {
    return (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
            <h1>❌ Payment Cancelled</h1>
            <p>Your payment was not completed.</p>
        </div>
    );
}